import React from 'react';
import {ScrollView, Text, TouchableOpacity, View} from 'react-native';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import FastImage from '../../Utils/FastImage';

import {
  ContinueButton,
  ExpandFullscreenButton,
  ImageButton,
} from 'src/Modules/CommonView/Buttons';
import {BodyText, HeaderText, HtmlBlock} from 'src/Modules/CommonView/Text';
import Timer from 'src/ScavengerHunt_v2/Game/Timer';

import FeatherIcon from 'react-native-vector-icons/Feather';
import FontAwesomeIcon from 'react-native-vector-icons/FontAwesome';
import Ionicon from 'react-native-vector-icons/Ionicons';
import MaterialCommunityIcon from 'react-native-vector-icons/MaterialCommunityIcons';
import LineIcon from 'react-native-vector-icons/SimpleLineIcons';

import {navigationRef} from 'src/Nav/navigationHelpers';
import {achievementsData} from 'src/Data/Achievements';
import CustomActivityIndicator from './CustomActivityIndicator';
import {AnimatedPointsEarned} from './Text';

const backButtonDarkIcon = require('src/Images/BackButtonDark.png');
const huntMapIcon = require('src/Images/Icons/huntMap.png');

export const PointsDisplay = ({previousGuesses = 0, pointsPossible = 100}) => {
  return (
    <AnimatedPointsEarned
      pointsEarned={pointsPossible - 20 * previousGuesses || 0}
    />
  );
};

export const ChallengeHeader = ({
  handleBackPress,
  text,
  hideBack,
  previousGuesses = 0,
  pointsPossible = 100,
  handleMapPress,
  containerStyle = {},
}) => {
  const {width} = useWindowDimensionsSafe();
  return (
    <View
      style={{
        alignItems: 'center',
        position: 'relative',
        width,
        marginTop: 10,
        ...containerStyle,
      }}>
      {!hideBack && (
        <ImageButton
          handlePress={handleBackPress}
          source={backButtonDarkIcon}
          imageStyle={{
            width: width > 350 ? 20 : 12,
            height: width > 350 ? 20 : 12,
          }}
          buttonStyle={{
            position: 'absolute',
            left: 10,
            top: 14,
            width: 40,
            height: 40,
          }}
        />
      )}
      <HeaderText bodyStyle={{width: 180}} text={text} />
      {!handleMapPress && (
        <PointsDisplay
          previousGuesses={previousGuesses}
          pointsPossible={pointsPossible}
        />
      )}
      {!!handleMapPress && (
        <ImageButton
          handlePress={handleMapPress}
          source={huntMapIcon}
          imageStyle={{
            width: 90,
            height: 40,
            marginVertical: 0,
            marginHorizontal: 0,
            ...global?.style.boxShadow,
          }}
          buttonStyle={{
            position: 'absolute',
            top: 0,
            right: 6,
          }}
        />
      )}
    </View>
  );
};

export const TimerHeader = ({
  text,
  seconds,
  countUp = false,
  startTime,
  completeTime,
  onComplete,
  handlePress,
  showBadge = false,
  isTimed = false,
}) => {
  const {width} = useWindowDimensionsSafe();
  console.log({text, isTimed});
  console.log('TimerHeader render', {startTime, completeTime});
  return (
    <TouchableOpacity
      style={{
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingVertical: 5,
        width,
      }}
      disabled={!handlePress}
      activeOpacity={0.8}
      onPress={handlePress}>
      <BodyText
        text={text}
        textStyle={{
          fontFamily: global?.font.gothic,
          fontSize: 20,
          lineHeight: 24,
          marginTop: 0,
          width: width - 140,
        }}
      />
      {!!startTime && !completeTime && !!isTimed && (
        <Timer
          seconds={seconds || 90}
          startTime={startTime}
          countUp={countUp}
          onComplete={onComplete}
          completeTime={completeTime}
          badge={showBadge}
        />
      )}
      {/* show completed time, forces re mount of Timer component. Built this way
      for timer reset between slides, otherwise timer is active && running in
      background for navigation challenges even after completion */}
      {!!startTime && !!completeTime && (
        <Timer
          seconds={seconds || 90}
          startTime={startTime}
          countUp={countUp}
          onComplete={onComplete}
          completeTime={completeTime}
          showBadge={showBadge}
        />
      )}
    </TouchableOpacity>
  );
};

export const UserThumbnail = ({
  name = ' ',
  photoUrl,
  photoColor = global?.color?.teal,
  size = 50,
}) => {
  return (
    <View
      style={{
        borderRadius: size / 2,
        height: size,
        position: 'relative',
        width: size,
      }}>
      <View
        style={{
          alignItems: 'center',
          backgroundColor: photoColor,
          borderRadius: size / 2,
          height: size,
          justifyContent: 'center',
          position: 'absolute',
          width: size,
        }}>
        <Text
          style={{
            color: global?.color?.white,
            fontFamily: global?.font.circular,
          }}>
          {name[0]}
        </Text>
      </View>
      {!!photoUrl && (
        <FastImage
          source={{uri: photoUrl}}
          style={{
            width: size,
            height: size,
            borderRadius: size / 2,
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        />
      )}
    </View>
  );
};

export const PhotoChoiceTile = ({photoUrl, handlePress}) => {
  const {width} = useWindowDimensionsSafe();
  const tileWidth = (width - 60) / 3;
  return (
    <TouchableOpacity
      style={{marginHorizontal: 5}}
      onPress={handlePress}
      disabled={!handlePress}
      activeOpacity={0.8}>
      <FastImage
        source={{uri: photoUrl}}
        style={{width: tileWidth, height: tileWidth}}
        resizeMode={FastImage?.resizeMode?.cover}
      />
    </TouchableOpacity>
  );
};

export const ChallengeBlock = ({title, question, directive}) => {
  return (
    <View style={{marginTop: 10, marginBottom: 20}}>
      <BodyText
        text={title}
        textStyle={{
          textAlign: 'center',
          fontSize: 14,
          lineHeight: 16,
          fontWeight: '700',
        }}
      />
      <HtmlBlock
        html={question || ''}
        htmlStyle={{
          fontStyle: 'italic',
          minHeight: 80,
          color: global?.color?.gray3,
          fontFamily: global?.font.circular,
          fontSize: 16,
          lineHeight: 20,
          marginTop: 10,
          marginHorizontal: 15,
        }}
      />
      {!!directive && <WideLine text={directive} />}
    </View>
  );
};

export const WideLine = ({text}) => {
  const {width} = useWindowDimensionsSafe();
  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 10,
        width: width - 20,
        marginHorizontal: 10,
      }}>
      <View
        style={{
          flex: 1,
          height: 2,
          backgroundColor: global?.color?.gray3,
        }}
      />
      <BodyText
        text={text}
        textStyle={{
          fontWeight: '700',
          marginTop: 0,
          fontSize: 12,
          lineHeight: 12,
        }}
      />
      <View
        style={{
          flex: 1,
          height: 2,
          backgroundColor: global?.color?.gray3,
        }}
      />
    </View>
  );
};

export const NonChallengeView = ({
  titleText,
  bodyText,
  buttonText,
  handleButtonPress,
  imageSource,
  replaceText,
  brandingSource,
  handleFullScreenPress,
  children,
  imageHeight,
}) => {
  const {width, height} = useWindowDimensionsSafe();
  return (
    <ScrollView style={{flex: 1, backgroundColor: 'white'}}>
      <View
        style={{
          flex: 1,
          paddingBottom: 60,
          backgroundColor: 'white',
        }}>
        <TimerHeader text={titleText} />
        {!!imageSource && (
          <View
            style={{
              alignItems: 'center',
              backgroundColor: global?.color?.white1,
              marginTop: 5,
              height: imageHeight || (height < 700 ? 220 : 290),
              justifyContent: 'center',
              position: 'relative',
              width,
            }}>
            <CustomActivityIndicator
              size={'small'}
              color={global?.color?.gray3}
              style={{position: 'absolute'}}
            />
            <FastImage
              style={{
                width,
                height: imageHeight || (height < 700 ? 220 : 290),
              }}
              source={imageSource}
              resizeMode={FastImage?.resizeMode?.cover}
            />
            {!!brandingSource && (
              <View
                style={{
                  backgroundColor: global?.color?.white,
                  position: 'absolute',
                  top: 5,
                  right: 5,
                  paddingHorizontal: 5,
                  justifyContent: 'flex-start',
                  alignItems: 'flex-end',
                }}>
                <FastImage
                  style={{
                    width: 70,
                    height: 50,
                  }}
                  source={{uri: brandingSource}}
                  resizeMode={FastImage?.resizeMode?.contain}
                />
              </View>
            )}
            {!!handleFullScreenPress && (
              <ExpandFullscreenButton handlePress={handleFullScreenPress} />
            )}
          </View>
        )}
        {!!bodyText && (
          <HtmlBlock
            html={bodyText || ''}
            htmlStyle={{fontSize: 16, lineHeight: 20}}
            replaceText={replaceText}
          />
        )}
        <View style={{alignItems: 'center'}}>
          {!!buttonText && (
            <ContinueButton
              text={buttonText}
              containerStyle={{width: 220}}
              handlePress={handleButtonPress}
            />
          )}
        </View>
        {!!children && children}
      </View>
    </ScrollView>
  );
};

export const AchievementIcon = ({
  size = 30,
  iconSet,
  icon,
  color = global?.color?.gray3,
}) => {
  const circleSize = 50;
  return (
    <View
      style={{
        alignItems: 'center',
        backgroundColor: global?.color?.white1,
        borderRadius: circleSize / 2,
        height: circleSize,
        justifyContent: 'center',
        width: circleSize,
      }}>
      {iconSet === 'FontAwesome' && (
        <FontAwesomeIcon name={icon} color={color} size={size} />
      )}
      {iconSet === 'MaterialCommunityIcons' && (
        <MaterialCommunityIcon name={icon} color={color} size={size} />
      )}
      {iconSet === 'Feather' && (
        <FeatherIcon name={icon} color={color} size={size} />
      )}
      {iconSet === 'Ionicons' && (
        <Ionicon name={icon} color={color} size={size} />
      )}
      {iconSet === 'SimpleLineIcons' && (
        <LineIcon name={icon} color={color} size={size} />
      )}
    </View>
  );
};

export const PlayerScoreCard = ({
  player,
  index,
  color,
  handlePress,
  cardWidth,
  containerStyle = {},
  characters = {},
}) => {
  var {
    character = 'Explorer',
    firstName = '',
    points = 0,
    achievements = [],
  } = player;

  const colors = [
    global?.color?.blue,
    global?.color?.teal,
    global?.color?.gray2,
    global?.color?.gray3,
  ];
  const characterSource = (characters[character] || characters.Explorer).source;

  const backgroundColor = color ? color : colors[index % 4];

  var formattedPoints;
  try {
    formattedPoints = Math.round(points);
  } catch (formatError) {
    console.log(formatError);
    formattedPoints = points;
  }

  return (
    <TouchableOpacity
      activeOpacity={0.8}
      style={{
        width: cardWidth,
        marginHorizontal: 10,
        marginVertical: 5,
        borderRadius: 10,
        ...containerStyle,
      }}
      onPress={handlePress}
      disabled={!handlePress}>
      <View
        style={{
          backgroundColor,
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          width: cardWidth,
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}>
        <BodyText
          text={firstName}
          textStyle={{marginVertical: 5, color: global?.color?.white}}
        />
        <BodyText
          text={`${formattedPoints} pts`}
          textStyle={{marginVertical: 5, color: global?.color?.white}}
        />
      </View>

      <View
        style={{
          backgroundColor: global?.color?.white,
          minHeight: 90,
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
        }}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}>
          <FastImage
            source={{uri: characterSource}}
            resizeMode={FastImage?.resizeMode?.contain}
            style={{width: 80, height: 80, marginVertical: 15, flex: 1}}
          />
          {!!achievements?.length &&
            achievements.slice(0, 2)?.map?.((key) => {
              const {
                name = '',
                level = '',
                iconSet,
                icon,
                color,
              } = achievementsData[key] || {};
              return (
                <View
                  key={`${key}_ach`}
                  style={{
                    alignItems: 'center',
                    minWidth: 120,
                    marginVertical: 10,
                  }}>
                  <AchievementIcon
                    iconSet={iconSet}
                    color={color}
                    icon={icon}
                  />
                  <BodyText
                    text={`${name}`}
                    textStyle={{
                      fontSize: 10,
                      marginTop: 5,
                      fontWeight: '700',
                    }}
                  />
                  {!!level && (
                    <BodyText
                      text={`(${level})`}
                      textStyle={{fontSize: 10, marginTop: 0}}
                    />
                  )}
                </View>
              );
            })}
        </View>
      </View>
    </TouchableOpacity>
  );
};

export const MultiChoiceAnswer = ({
  completions,
  teamName,
  answers,
  players,
  postContent = '',
  pointsEarned,
}) => {
  console.log('MultiChoiceAnswer render');

  const correctAnswer = answers.find((answer) => answer.correct) || {};
  const answeredCorrectly =
    Object.values(completions).filter((completion) => {
      return completion.answeredCorrectly;
    }) || [];
  const answered = (Object.values(completions) || []).sort((a, b) => {
    return a === b ? 0 : a ? -1 : 1;
  });

  const formattedPostContent =
    postContent &&
    postContent
      .replace(/<p>/gi, '')
      .replace(/<\/p>/gi, '')
      .replace(/\[TEAM_NAME\]/gi, teamName);

  return (
    <View>
      <BodyText
        text={'The Correct Answer Was:'}
        textStyle={{
          marginVertical: 10,
          textAlign: 'center',
          fontWeight: '700',
        }}
      />
      <View style={{alignItems: 'center'}}>
        <ContinueButton
          text={correctAnswer.option}
          textStyle={{color: global?.color?.gray3}}
          containerStyle={{minWidth: 220}}
          background={global?.color?.white1}
          icon={'flag'}
          handlePress={() => {
            navigationRef.navigate('ReportModal');
          }}
        />
        {!!postContent && (
          <BodyText textStyle={{fontSize: 16, lineHeight: 18}}>
            {formattedPostContent}
          </BodyText>
        )}
      </View>
      <View style={{alignItems: 'center', marginVertical: 5}}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginHorizontal: 10,
            marginTop: 10,
            flexWrap: 'wrap',
          }}>
          {answered?.map?.((completion) => {
            let completionUser = players?.[completion?.userId] || {};
            let {firstName, photoUrl, photoColor} = completionUser;
            return (
              <View
                style={{
                  marginHorizontal: 5,
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: 40,
                  height: 40,
                }}
                key={`${completion.userId}_answ`}>
                <UserThumbnail
                  name={firstName}
                  size={30}
                  photoUrl={photoUrl}
                  photoColor={photoColor}
                />
                <View
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                  }}>
                  <FontAwesomeIcon
                    size={22}
                    color={completion.answeredCorrectly ? 'green' : 'red'}
                    name={completion.answeredCorrectly ? 'check' : 'times'}
                  />
                </View>
              </View>
            );
          })}
        </View>
        {!!answeredCorrectly?.length && (
          <BodyText
            text={`Correct: +${Math.round(
              pointsEarned || (answeredCorrectly?.length || 0) * 100,
            )} pts`}
            textStyle={{fontWeight: '700'}}
          />
        )}
      </View>
    </View>
  );
};
